import { useCallback } from 'react'
import type { AnalyticsEventName } from './analytics'
import { trackEvent } from './analytics'

export function useAnalytics() {
  const track = useCallback(
    (eventName: AnalyticsEventName, eventData?: Record<string, unknown>) =>
      trackEvent(eventName, eventData),
    []
  )

  return { trackEvent: track }
}
